ChoosePaymentController.$inject = ["API_URL", "$http", "PaymentOptionService", "$rootScope", "$location", "$filter", "$timeout"];
angular.module('calendarApp').controller('ChoosePaymentController', ChoosePaymentController);

function ChoosePaymentController(API_URL, $http, PaymentOptionService, $rootScope, $location, $filter, $timeout) {
  var pay = this;

  pay.init = function () {
    var updateType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    pay.updateType = updateType;
    pay.membershipProcessing = false; // All appointments at this stage must be in local storage

    var appointments = localStorage.getItem('reserved-appointments');

    if (!appointments) {
      $location.path('/');
      return;
    }

    appointments = JSON.parse(appointments);
    pay.appointments = appointments;
    pay.currencySettings = smooth.currencySettings;
    pay.couponLoading = [];
    pay.couponErrorMessage = [];
    pay.couponSuccessMessage = [];
    pay.serviceID = appointments[0].serviceid._id;
    pay.shiftID = appointments[0].shiftid._id || appointments[0].shiftid; // Retrieve payment options for this user and this service

    $rootScope.throbber && $rootScope.throbber.show();
    pay.loading = true;
    $http.get(API_URL + '/api/v1/calendar/payment/options/' + pay.shiftID).then(function (reply) {
      pay.loading = false;
      $rootScope.throbber && $rootScope.throbber.hide();
      var response = reply.data;

      if (!response.success) {
        var errorMessage = $filter('calendarLabel')('Sorry but an error occurred: ');
        $rootScope.throbber && $rootScope.throbber.showError(errorMessage + ' ' + response.msg);
        return;
      }

      pay.serviceMembership = PaymentOptionService.payByMembership(pay.serviceID, response.paymentoptions);

      if (!!pay.serviceMembership) {
        return;
      }

      pay.defaultPayment = response.defaultpayment || null;

      try {
        pay.paymentState = PaymentOptionService.init(response.paymentoptions, appointments.length, response.paymentoptions.appointmentsInWorkshop);
      } catch (e) {
        console.error('Error in payment option service: ' + e);
      }
    }).catch(function (error) {
      pay.loading = false;
      $rootScope.throbber && $rootScope.throbber.hide();
      var errorMessage = $filter('calendarLabel')('Sorry but an error occurred: ');
      $rootScope.throbber && $rootScope.throbber.showError(errorMessage + ' ' + response.msg);
    });
  };

  $rootScope.$watch('outstandingInvoices', function () {
    pay.outstandingInvoices = $rootScope.outstandingInvoices;
  });
  pay.init();

  pay.payWithMembership = function () {
    // All appointments at this stage must be in local storage
    var storedAppointments = localStorage.getItem('reserved-appointments');

    if (!storedAppointments) {
      $location.path('/');
      return;
    }

    pay.membershipProcessing = true;
    var appointments = JSON.parse(storedAppointments);
    if (!appointments || !appointments.length) return $rootScope.throbber.showError("We're sorry but we could not find any appointments to confirm. If this is in error please contact support@smoothbook.co");
    var serviceMembership = pay.serviceMembership,
        throbber = $rootScope.throbber;

    if (!serviceMembership) {
      return alert('Sorry but your membership was not found. Please contact support@smoothbook.co if this problem persists');
    }

    throbber.show();
    $http.post(API_URL + '/api/v1/calendar/membership/payments/' + pay.serviceMembership.membershipid, {
      appointments: appointments
    }).then(function (reply) {
      throbber.hide();
      var response = reply.data;
      pay.membershipProcessing = false;

      if (!response.success) {
        return throbber.showError("Sorry but there was an error with this request: ".concat(response.msg));
      }

      var newAppointments = response.newAppointments; // Update localStorage

      localStorage.removeItem('reserved-appointments');
      localStorage.setItem('new-appointments', JSON.stringify(newAppointments));
      $location.path('/confirm');
    }).catch(function (err) {
      pay.membershipProcessing = false;
      throbber.showError("Sorry but an unexpected error occurred: ".concat(err.message, ". Please contact support@smoothbook.co if this error persists"));
    });
  };

  pay.continue = function () {
    // Store payment state
    localStorage.setItem('payment-state', JSON.stringify(pay.paymentState));
    $location.path('payment');
  };

  pay.updateCustomerCredit = function (packageID, number, direction) {
    pay.paymentState = PaymentOptionService.updateCustomerCredit(packageID, number, direction);
  };

  pay.updatePackage = function (packageID, direction) {
    pay.paymentState = PaymentOptionService.updatePackage(packageID, direction);
  };

  pay.updateSingleAppointment = function (add) {
    pay.paymentState = PaymentOptionService.updateSingleAppointment(add);
  };

  pay.updateWorkshop = function (add) {
    pay.paymentState = PaymentOptionService.updateWorkshop(add);
  };

  pay.validateCoupon = function (packageID, $index) {
    var couponValue = pay.couponValue[$index];

    if (!couponValue) {
      return;
    }

    pay.couponLoading[$index] = true;
    $http.get(API_URL + '/api/v1/calendar/payment/validatecoupon/' + packageID, {
      params: {
        coupon: couponValue
      }
    }).then(function (reply) {
      pay.couponLoading[$index] = false;
      var response = reply.data,
          paymentState;

      if (!response.success) {
        pay.couponErrorMessage[$index] = response.msg;
        $timeout(function () {
          pay.couponErrorMessage[$index] = '';
        }, 3000);
        return;
      }

      pay.couponSuccessMessage[$index] = $filter('calendarLabel')('Coupon valid. Please click buy to purchase this package');
      $timeout(function () {
        try {
          // Success. Update the payment state with the coupon.
          paymentState = PaymentOptionService.addCoupon(packageID, couponValue);
        } catch (e) {
          pay.couponErrorMessage[$index] = e;
          $timeout(function () {
            pay.couponErrorMessage[$index] = '';
          }, 3000);
        }

        pay.couponSuccessMessage[$index] = '';
      }, 3000);
    }, function (error) {
      pay.couponErrorMessage[$index] = error;
      $timeout(function () {
        pay.couponErrorMessage[$index] = '';
      }, 3000);
    });
  };

  pay.cancel = function () {
    var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

    if (!confirm(cancelMessage)) {
      return;
    }

    $location.path('/');
  };
}